@if (!loading) {
  @if (entryFeeToDisplay) {
    @if (entryFeeToDisplay.entryRegularFeeIncludingVat > 0 || entryFeeToDisplay.entryOneTimeFeeIncludingVat > 0) {
      <div
        class="entry-fee-calc-title mb-3"
        [ngClass]="{'dark-color': useStrategyStyling}"
        >
        {{ 'entryFeeCalc.title' | translate }}
      </div>
      @if (entryFeeToDisplay.entryRegularFeeIncludingVat > 0) {
        <libero-entry-fee-calc-item
          [type]="'REGULAR'"
          [feeIncludingVat]="entryFeeToDisplay.entryRegularFeeIncludingVat"
          [feeVat]="entryFeeToDisplay.entryRegularFeeVat"
          [feeRatio]="entryFeeToDisplay.entryRegularRatio"
          [discountRegularDeposit]="entryFeeToDisplay.discountRegularDeposit"
          [currencyCode]="currencyCode"
          [useStrategyStyling]="useStrategyStyling"
        ></libero-entry-fee-calc-item>
      }
      @if (entryFeeToDisplay.entryOneTimeFeeIncludingVat > 0) {
        <libero-entry-fee-calc-item
          [type]="'ONETIME'"
          [feeIncludingVat]="entryFeeToDisplay.entryOneTimeFeeIncludingVat"
          [feeVat]="entryFeeToDisplay.entryOneTimeFeeVat"
          [feeRatio]="entryFeeToDisplay.entryOneTimeRatio"
          [currencyCode]="currencyCode"
          [useStrategyStyling]="useStrategyStyling"
        ></libero-entry-fee-calc-item>
      }
    }
  }
} @else {
  <div class="preload-container">
    <libero-preload-spinner
      data-cy="entry-fee-calc-spinner"
    ></libero-preload-spinner>
  </div>
}
